import { ImagesPage } from "./images";

export const Images = ImagesPage;
